import React, { createContext, useContext, useState, ReactNode } from 'react';

interface Translations {
  [key: string]: string;
}

interface TranslationContextType {
  language: 'en' | 'vi';
  setLanguage: (lang: 'en' | 'vi') => void;
  t: (key: string) => string;
  getLocalizedContent: (content: any, field: string) => string;
}

const vietnameseTranslations: Translations = {
  // Navigation
  'Home': 'Trang Chủ',
  'Tours': 'Tour Du Lịch',
  'Services': 'Dịch Vụ',
    'Other travel services': 'Dịch Vụ Du Lịch',
  'Blogs': 'Tin Tức',
    'News': 'Tin Tức',
  'Contact': 'Liên Hệ',
  'Admin': 'Quản Trị',
  'Admin Dashboard': 'Bảng Điều Khiển',
  'Logout': 'Đăng Xuất',
  'Login': 'Đăng Nhập',

  // Common Actions
  'Book Now': 'Đặt Ngay',
  'Learn More': 'Tìm Hiểu Thêm',
  'Read More': 'Đọc Thêm',
  'View More': 'Xem Thêm',
  'View Details': 'Xem Chi Tiết',
  'Submit': 'Gửi',
  'Send Message': 'Gửi Tin Nhắn',
  'Search': 'Tìm Kiếm',
  'Filter': 'Lọc',
  'Sort': 'Sắp Xếp',
  'Clear': 'Xóa',
  'Cancel': 'Hủy',
  'Close': 'Đóng',
  'Save': 'Lưu',
  'Edit': 'Chỉnh Sửa',
  'Delete': 'Xóa',
  'Add': 'Thêm',
  'Update': 'Cập Nhật',
  'Back': 'Quay Lại',
  'Next': 'Tiếp Theo',
  'Previous': 'Trước',
  'Continue': 'Tiếp Tục',
  'Finish': 'Hoàn Thành',
  'Download': 'Tải Xuống',
  'Upload': 'Tải Lên',
  'Share': 'Chia Sẻ',

  // Home Page - Hero Section
  'All tours from Trang Thanh Travel': 'Tất cả tours đến từ Trang Thanh Travel',
  'Explore the world with our expert guides': 'Khám phá thế giới cùng hướng dẫn viên chuyên nghiệp',
  'Get started on your next adventure': 'Bắt đầu cuộc phiêu lưu tiếp theo của bạn',

  // Home Page - Main Sections
  'Featured Tours': 'Các Tour Nổi Bật',
  'Popular Destinations': 'Điểm Đến Phổ Biến',
  'Why Choose Us': 'Tại Sao Chọn Chúng Tôi',
  'Explore our services': 'Khám phá các dịch vụ nổi bật của Trang Thanh Travel.',
    'Our Services': 'Dịch Vụ Của Chúng Tôi',
    'Happy Customers': 'Khách Hàng Hài Lòng',
  'Experience in the industry': 'Năm Kinh Nghiệm',
  'Successful Journey': 'Hành Trình Trọn Vẹn',
  'Rating on Google': 'Điểm đánh Giá Trên Google',
  'Customer Reviews': 'Đánh Giá Khách Hàng',
  'Latest News': 'Tin Tức Mới Nhất',
  'Comprehensive travel solutions to make your journey seamless and memorable': 'Giải pháp du lịch toàn diện để làm cho hành trình của bạn trở nên liền mạch và đáng nhớ',

  // Tours Page
  'All Tours': 'Tất Cả Tour',
  'Explore our best-selling tours': 'Khám phá các tour du lịch bán chạy nhất của Trang Thanh Travel.',
    'Discover our wide selection of tours, from domestic and international tours to tailored inbound tours for international tourists visiting Vietnam.': 'Khám phá tất cả các tours du lịch trong nước, nước ngoài và tour inbound cho du khách đến Việt Nam.',
    'Search destinations, tours...': 'Tìm kiếm điểm đến, tour...',
  'Search tours...': 'Tìm kiếm tour...',
  'Minimum': 'Tối thiểu',
  'Maximum': 'Tối đa',
  'tours found': 'tour được tìm thấy',
  'Error loading tours': 'Lỗi khi tải tour',
  'Please try again later or adjust your filters.': 'Vui lòng thử lại sau hoặc điều chỉnh bộ lọc của bạn.',
  'Try Again': 'Thử Lại',
  'No tours found': 'Không tìm thấy tour',
  'Try adjusting your filters or search keywords.': 'Thử điều chỉnh bộ lọc hoặc từ khóa tìm kiếm của bạn.',
  'Tour Categories': 'Danh Mục Tour',
  'Duration': 'Thời Gian',
  'Price': 'Giá',
  'Difficulty': 'Độ Khó',
  'Group Size': 'Số Lượng Khách',
  'Tour Details': 'Chi Tiết Tour',
  'Itinerary': 'Lịch Trình',
  'Inclusions': 'Bao Gồm',
  'Exclusions': 'Không Bao Gồm',
  'What to Bring': 'Những Gì Cần Mang',
  'Tour Gallery': 'Thư Viện Ảnh Tour',
  'Similar Tours': 'Tour Tương Tự',
  'days': 'ngày',
  'day': 'ngày',
  'nights': 'đêm',
  'night': 'đêm',
  'from': 'từ',
  'per person': 'mỗi người',
  'Starting from': 'Bắt đầu từ',
  'Tour Type': 'Loại Tour',
  'Available Dates': 'Ngày Có Sẵn',
  'Meeting Point': 'Điểm Hẹn',
  'Language': 'Ngôn Ngữ',
  'Age Restriction': 'Hạn Chế Tuổi',
  'Physical Rating': 'Đánh Giá Thể Chất',
  'Overview': 'Tổng Quan',
  'Highlights': 'Điểm Nổi Bật',
  'What\'s Included': 'Bao Gồm Gì',
  'What\'s Not Included': 'Không Bao Gồm Gì',
  'Important Notes': 'Ghi Chú Quan Trọng',
  'Cancellation Policy': 'Chính Sách Hủy Tour',
  'Reviews': 'Đánh Giá',
  'Write a Review': 'Viết Đánh Giá',

  // Services Page
  'Our Professional Services': 'Dịch Vụ Chuyên Nghiệp',
  'Complete travel solutions for all your adventure needs': 'Giải pháp du lịch toàn diện để làm cho hành trình của bạn trở nên liền mạch và đáng nhớ',
    'In addition to our tours and car rental services, we also offer a variety of other services to ensure your trip is seamless and unforgettable.': 'Ngoài các tour du lịch và dịch vụ cho thuê xe, chúng tôi còn cung cấp nhiều dịch vụ khác để đảm bảo hành trình của bạn diễn ra suôn sẻ và trọn vẹn.',
    'Private Car Rental': 'Dịch Vụ Thuê Xe Riêng',
    'Car Rental': 'Thuê Xe',
  'Car Rental Services': 'Dịch Vụ Thuê Xe',
  'Car Rentals': 'Thuê Xe',
  'Experience the ultimate in convenience and comfort with our private car rental service. Whether you\'re traveling for business or pleasure, our meticulously maintained fleet offers a wide selection of vehicles to suit your every need, from standard to luxury.': 'Trải nghiệm sự tiện nghi và thoải mái với dịch vụ thuê xe riêng của chúng tôi. Dù là đi công tác hay du lịch, đội xe được bảo dưỡng tỉ mỉ của chúng tôi luôn sẵn sàng phục vụ với nhiều lựa chọn đa dạng, phục vụ  mọi nhu cầu của khách hàng.',
  'Search car rentals...': 'Tìm kiếm dịch vụ thuê xe...',
  'Choose from our premium vehicle fleet': 'Chọn từ đội xe cao cấp của chúng tôi',
  'View All Car Rentals': 'Xem Tất Cả Dịch Vụ Thuê Xe',
  'No Featured Tours Available': 'Không Có Tour Nổi Bật',
  "We're working on adding some amazing featured tours for you.": 'Chúng tôi đang làm việc để thêm những tour tuyệt vời cho bạn.',
  'Browse All Tours': 'Duyệt Tất Cả Tour',
  'Have a question or ready to book your next adventure?': 'Hãy liên hệ với chúng tôi ngay để bắt đầu lên kế hoạch cho chuyến đi của bạn.',
  'Contact us now to start planning your perfect trip. Our team of travel experts is here to help with any inquiries you may have.': 'Đội ngũ chuyên gia của chúng tôi luôn sẵn sàng giải đáp mọi thắc mắc của khách hàng.',
  'Looking for travel ideas, local tips, or the latest on tourism in Vietnam? You’re in the right place. We share stories, updates, and inspiration to help you best plan your trip.': 'Bạn đang tìm kiếm ý tưởng, mẹo vặt du lịch hay những thông tin mới nhất về ngành du lịch tại Việt Nam? Hãy ghé thăm trang tin tức của chúng tôi thường xuyên để có những cập nhật mới nhất.',
  'Newest First': 'Mới Nhất Trước',
  'Oldest First': 'Cũ Nhất Trước',
  'Price: Low to High': 'Giá: Thấp Đến Cao',
  'Price: High to Low': 'Giá: Cao Đến Thấp',
  'Name: A to Z': 'Tên: A đến Z',
  'Name: Z to A': 'Tên: Z đến A',
  'View Mode': 'Chế Độ Xem',
  'Hotel Booking': 'Đặt Khách Sạn',
  'Flight Booking': 'Đặt Vé Máy Bay',
  'Visa Services': 'Dịch Vụ Visa',
  'Travel Insurance': 'Bảo Hiểm Du Lịch',
  'Event Planning': 'Tổ Chức Sự Kiện',
  'Service Details': 'Chi Tiết Dịch Vụ',
  'Available Services': 'Dịch Vụ Có Sẵn',
  'Service Features': 'Tính Năng Dịch Vụ',
  'Service Gallery': 'Thư Viện Ảnh Dịch Vụ',
  'Request Quote': 'Yêu Cầu Báo Giá',
  'Book Service': 'Đặt Dịch Vụ',
  'Book This Service': 'Đặt Dịch Vụ Này',
  'Service Type': 'Loại Dịch Vụ',
  'Availability': 'Tình Trạng',
  'Available': 'Có Sẵn',
  'Response Time': 'Thời Gian Phản Hồi',
  'Within 2 hours': 'Trong Vòng 2 Giờ',
  'Contact for Custom Quote': 'Liên Hệ Để Báo Giá Riêng',
  'Service Not Found': 'Không Tìm Thấy Dịch Vụ',
  'The service you\'re looking for doesn\'t exist or has been removed.': 'Dịch vụ bạn đang tìm kiếm không tồn tại hoặc đã bị xóa.',
  'Browse All Services': 'Xem Tất Cả Dịch Vụ',
  'General Service': 'Dịch Vụ Tổng Quát',
  'per service': 'mỗi dịch vụ',
  'No description available for this service.': 'Không có mô tả cho dịch vụ này.',
  'No services available at the moment.': 'Hiện tại không có dịch vụ nào.',
  'Error loading services': 'Lỗi khi tải dịch vụ',
  'Please try again later': 'Vui lòng thử lại sau',
  'services found': 'dịch vụ được tìm thấy',
  'No services found': 'Không tìm thấy dịch vụ',
  'Try adjusting your search or filters.': 'Thử điều chỉnh tìm kiếm hoặc bộ lọc của bạn.',
  'Search services...': 'Tìm kiếm dịch vụ...',
  'Title Z-A': 'Tiêu Đề Z-A',
  'Price Low to High': 'Giá Thấp Đến Cao',
  'Price High to Low': 'Giá Cao Đến Thấp',
  'Service': 'Dịch Vụ',

  // Contact Page
  'Get in Touch': 'Liên Hệ Với Chúng Tôi',
    'Contact Us': 'Liên Hệ',
  'We are always ready to help you plan the perfect trip. Contact us today!': 'Chúng tôi luôn sẵn sàng hỗ trợ bạn lên kế hoạch cho chuyến du lịch hoàn hảo. Hãy liên hệ với chúng tôi ngay hôm nay!',
    'Have a question or ready to book your next adventure? Contact us now to start planning your perfect trip. Our team of travel experts is here to help with any inquiries you may have': 'Hãy liên hệ với chúng tôi ngay để bắt đầu lên kế hoạch cho chuyến đi của bạn. Đội ngũ chuyên gia của chúng tôi luôn sẵn sàng giải đáp mọi thắc mắc của khách hàng.',
    'Contact Information': 'Thông Tin Liên Hệ',
  'Send us a Message': 'Gửi Tin Nhắn Cho Chúng Tôi',
  'Full Name': 'Họ và Tên',
  'Email Address': 'Địa Chỉ Email',
  'Phone Number': 'Số Điện Thoại',
  'Subject': 'Chủ Đề',
  'Message': 'Tin Nhắn',
  'Your message': 'Tin nhắn của bạn',
  'Office Address': 'Địa Chỉ Văn Phòng',
  'Business Hours': 'Giờ Làm Việc',
  'Monday - Friday': 'Thứ Hai - Thứ Sáu',
  'Saturday': 'Thứ Bảy',
  'Sunday': 'Chủ Nhật',
  'Closed': 'Đóng Cửa',

  // Blogs Page
  'Travel Blog': 'Blog Du Lịch',
  'Discover amazing destinations and travel tips from our experts': 'Khám phá những điểm đến tuyệt vời và mẹo du lịch từ các chuyên gia của chúng tôi',
    'Looking for travel ideas, local tips, or the latest on tourism in Vietnam? You’re in the right place. We share stories, updates, and inspiration to help you best plan your trip': 'ạn đang tìm kiếm ý tưởng, mẹo vặt du lịch hay những thông tin mới nhất về ngành du lịch tại Việt Nam? Hãy ghé thăm trang tin tức của chúng tôi thường xuyên để có những cập nhật mới nhất',
    'Error Loading Blogs': 'Lỗi Khi Tải Blog',
  'Sorry, we couldn\'t load the blogs. Please try again.': 'Xin lỗi, chúng tôi không thể tải blog. Vui lòng thử lại.',
  'All Categories': 'Tất Cả Danh Mục',
  'Most Recent': 'Mới Nhất',
  'Most Popular': 'Phổ Biến Nhất',
  'Show Filters': 'Hiển Thị Bộ Lọc',
  'Hide Filters': 'Ẩn Bộ Lọc',
  'Clear All Filters': 'Xóa Tất Cả Bộ Lọc',
  'No blogs found': 'Không tìm thấy blog',
  'Search blogs...': 'Tìm kiếm blog...',
  'Latest First': 'Mới Nhất Trước',
  'Title A-Z': 'Tiêu Đề A-Z',
  'Clear Filters': 'Xóa Bộ Lọc',
  'Try adjusting your search or filters': 'Thử điều chỉnh tìm kiếm hoặc bộ lọc của bạn',

  // Blog Detail Page
  'Latest Articles': 'Bài Viết Mới Nhất',
  'Travel Tips': 'Mẹo Du Lịch',
  'Destinations': 'Điểm Đến',
  'Travel Guides': 'Hướng Dẫn Du Lịch',
  'Published on': 'Xuất Bản Vào',
  'Read Time': 'Thời Gian Đọc',
  'minutes': 'phút',
  'minute': 'phút',
  'Related Articles': 'Bài Viết Liên Quan',
  'Share Article': 'Chia Sẻ Bài Viết',
  'Categories': 'Danh Mục',
  'Tags': 'Thẻ',
  'Comments': 'Bình Luận',
  'Leave a Comment': 'Để Lại Bình Luận',
  'Your Comment': 'Bình Luận Của Bạn',
  'Post Comment': 'Đăng Bình Luận',

  // About Page
  'About Us': 'Về Chúng Tôi',
  'Learn more about our company and our commitment to excellence': 'Tìm hiểu thêm về công ty và cam kết về chất lượng của chúng tôi.',
  'Our Story': 'Câu Chuyện Của Chúng Tôi',
  'Mission': 'Sứ Mệnh',
  'Vision': 'Tầm Nhìn',
  'Our Team': 'Đội Ngũ',
  'Company History': 'Lịch Sử Công Ty',
  'Awards & Recognition': 'Giải Thưởng & Công Nhận',
  'Core Values': 'Giá Trị Cốt Lõi',
    'Quality Service': 'Dịch Vụ Chất Lượng',
    'Customer Satisfaction': 'Sự Hài Lòng Khách Hàng',
    'Sustainable Tourism': 'Du Lịch Bền Vững',
    'Local Expertise': 'Chuyên Môn Địa Phương',
    'What We Do': 'Chúng Tôi Làm Gì',
    'Our professional travel services designed to make your journey unforgettable': 'Dịch vụ du lịch chuyên nghiệp của chúng tôi được thiết kế để làm cho hành trình của bạn trở nên khó quên',
    'Vision & Mission': 'Tầm Nhìn & Sứ Mệnh',
    'Passion': 'Đam Mê',
    'Trust': 'Tin Cậy',
    'Excellence': 'Xuất Sắc',
    'We are passionate about travel and dedicated to sharing that enthusiasm with every customer.': 'Chúng tôi đam mê du lịch và tận tâm chia sẻ niềm đam mê đó với mọi khách hàng.',
    'We build lasting relationships based on trust, transparency, and reliable service delivery.': 'Chúng tôi xây dựng mối quan hệ lâu dài dựa trên sự tin cậy, minh bạch và cung cấp dịch vụ đáng tin cậy.',
    'We strive for excellence in every aspect of our service, from planning to execution.': 'Chúng tôi phấn đấu đạt được sự xuất sắc trong mọi khía cạnh của dịch vụ, từ lập kế hoạch đến thực hiện.',
    'Ready to Start Your Journey?': 'Sẵn Sàng Bắt Đầu Hành Trình?',
    'Join thousands of satisfied travelers who have discovered amazing destinations with us. Let us help you create your perfect travel experience.': 'Tham gia cùng hàng nghìn du khách hài lòng đã khám phá những điểm đến tuyệt vời cùng chúng tôi. Hãy để chúng tôi giúp bạn tạo ra trải nghiệm du lịch hoàn hảo.',
    'Explore Tours': 'Khám Phá Tour',
    '15+ Years of Excellence': '15+ Năm Xuất Sắc',
    'Serving travelers since 2009': 'Phục vụ du khách từ năm 2009',


    // Tour Detail Page - Additional translations
  'Tour Not Found': 'Không Tìm Thấy Tour',
  "The tour you're looking for doesn't exist or has been removed.": 'Tour bạn đang tìm kiếm không tồn tại hoặc đã bị xóa.',
  'Duration TBD': 'Thời Gian Chưa Xác Định',
  'Max': 'Tối Đa',
  'People': 'Người',
  'reviews': 'đánh giá',
  'About This Tour': 'Về Tour Này',
  'Tour description coming soon...': 'Mô tả tour sẽ được cập nhật sớm...',
  'Tour Highlights': 'Điểm Nổi Bật Của Tour',
  'Day by Day Itinerary': 'Lịch Trình Từng Ngày',
  'Activities': 'Hoạt Động',
  'Meals': 'Bữa Ăn',
  'Accommodation': 'Chỗ Ở',
  'Photo Gallery': 'Thư Viện Ảnh',
  'photos': 'ảnh',
  'Included': 'Bao Gồm',
  'Not Included': 'Không Bao Gồm',
  'Inclusions information coming soon...': 'Thông tin bao gồm sẽ được cập nhật sớm...',
  'Exclusions information coming soon...': 'Thông tin không bao gồm sẽ được cập nhật sớm...',
  'Location': 'Vị Trí',
  'Interactive map would be embedded here': 'Bản đồ tương tác sẽ được nhúng ở đây',
  'per group': 'mỗi nhóm',
   'Minimum Age': 'Tuổi Tối Thiểu',
  'years': 'tuổi',
  'Free cancellation up to 24 hours before': 'Hủy miễn phí trong vòng 24 giờ trước',

  // Booking Policy Page
  'Booking Terms & Conditions': 'Điều Khoản & Điều Kiện Đặt Tour',
  'Please read our booking terms and conditions carefully before making a reservation': 'Vui lòng đọc kỹ các điều khoản và điều kiện đặt tour của chúng tôi trước khi đặt chỗ',
  'Terms of Service': 'Điều Khoản Dịch Vụ',
  'Privacy Policy': 'Chính Sách Bảo Mật',
  'Refund Policy': 'Chính Sách Hoàn Tiền',
  'Liability': 'Trách Nhiệm Pháp Lý',
  'Force Majeure': 'Bất Khả Kháng',

  // Booking Page
  'Book Your Tour': 'Đặt Tour Của Bạn',
  'Booking Details': 'Chi Tiết Đặt Tour',
  'Personal Information': 'Thông Tin Cá Nhân',
  'Travel Date': 'Ngày Du Lịch',
  'Number of Travelers': 'Số Lượng Du Khách',
  'Adults': 'Người Lớn',
  'Children': 'Trẻ Em',
  'Infants': 'Trẻ Sơ Sinh',
  'Special Requirements': 'Yêu Cầu Đặc Biệt',
  'Total Price': 'Tổng Giá',
  'Confirm Booking': 'Xác Nhận Đặt Tour',
  'Booking Summary': 'Tóm Tắt Đặt Tour',
  'Payment Method': 'Phương Thức Thanh Toán',
  'Customer Information': 'Thông Tin Khách Hàng',
  'Emergency Contact': 'Liên Hệ Khẩn Cấp',
  'Emergency Contact Name': 'Tên Người Liên Hệ Khẩn Cấp',
  'Emergency Contact Phone': 'Điện Thoại Liên Hệ Khẩn Cấp',
  'Relationship': 'Mối Quan Hệ',
  'Special Requests': 'Yêu Cầu Đặc Biệt',
  'Dietary Requirements': 'Yêu Cầu Chế Độ Ăn',
  'Medical Conditions': 'Tình Trạng Y Tế',
  'Accessibility Needs': 'Nhu Cầu Hỗ Trợ',
  'Additional Notes': 'Ghi Chú Thêm',
  'Total Travelers': 'Tổng Số Du Khách',
  'Base Price': 'Giá Cơ Bản',
  'Total Amount': 'Tổng Số Tiền',
  'Price per Person': 'Giá Mỗi Người',
  'Booking Fee': 'Phí Đặt Tour',
  'Tax': 'Thuế',
  'Final Total': 'Tổng Cộng Cuối',
  'Processing...': 'Đang Xử Lý...',
  'Start Date': 'Ngày Bắt Đầu',
  'Select Date': 'Chọn Ngày',

  // Service Booking Page
  'Service Booking': 'Đặt Dịch Vụ',
  'Service Information': 'Thông Tin Dịch Vụ',
  'Service Date': 'Ngày Dịch Vụ',
  'Service Duration': 'Thời Gian Dịch Vụ',
  'Service Location': 'Địa Điểm Dịch Vụ',
  'Pick-up Location': 'Địa Điểm Đón',
  'Drop-off Location': 'Địa Điểm Trả',
  'Preferred Time': 'Thời Gian Ưa Thích',
  'Number of People': 'Số Lượng Người',
  'Vehicle Type': 'Loại Xe',
  'Room Type': 'Loại Phòng',
  'Check-in Date': 'Ngày Nhận Phòng',
  'Check-out Date': 'Ngày Trả Phòng',
  'Number of Rooms': 'Số Phòng',
  'Number of Guests': 'Số Khách',

  // Car Rental Page
  'Rent a Car': 'Thuê Xe',
  'Pick-up Date': 'Ngày Nhận Xe',
  'Return Date': 'Ngày Trả Xe',
  'Pick-up Time': 'Giờ Nhận Xe',
  'Return Time': 'Giờ Trả Xe',
  'Driver Age': 'Tuổi Tài Xế',
  'With Driver': 'Có Tài Xế',
  'Self Drive': 'Tự Lái',
  'Car Features': 'Tính Năng Xe',
  'Fuel Type': 'Loại Nhiên Liệu',
  'Transmission': 'Hộp Số',
  'Seats': 'Số Ghế',
  'Air Conditioning': 'Điều Hòa',
  'GPS Navigation': 'Định Vị GPS',
  'Insurance': 'Bảo Hiểm',

  // Form Validation & Messages
  'Name is required': 'Tên là bắt buộc',
  'Email is required': 'Email là bắt buộc',
  'Invalid email': 'Email không hợp lệ',
  'Phone is required': 'Số điện thoại là bắt buộc',
  'Invalid phone number': 'Số điện thoại không hợp lệ',
  'Subject is required': 'Chủ đề là bắt buộc',
  'Message is required': 'Tin nhắn là bắt buộc',
  'Date is required': 'Ngày là bắt buộc',
  'Invalid date': 'Ngày không hợp lệ',
  'Field is required': 'Trường này là bắt buộc',
  'Please fill in all required fields': 'Vui lòng điền tất cả các trường bắt buộc',
  'Please select a valid option': 'Vui lòng chọn một tùy chọn hợp lệ',
  'Minimum length is': 'Độ dài tối thiểu là',
  'Maximum length is': 'Độ dài tối đa là',
  'characters': 'ký tự',

  // Success & Error Messages
  'Success': 'Thành Công',
  'Error': 'Lỗi',
  'Warning': 'Cảnh Báo',
  'Information': 'Thông Tin',
  'Message sent successfully': 'Tin nhắn đã được gửi thành công',
  'Booking submitted successfully': 'Đặt tour đã được gửi thành công',
  'We will contact you soon': 'Chúng tôi sẽ liên hệ với bạn sớm',
  'Something went wrong': 'Đã xảy ra lỗi',
  'Please try again': 'Vui lòng thử lại',
  'Loading...': 'Đang tải...',
  'Failed to load': 'Không thể tải',
  'No data available': 'Không có dữ liệu',
  'Data not found': 'Không tìm thấy dữ liệu',

  // Status & States
  'Unavailable': 'Không Có Sẵn',
  'Sold Out': 'Hết Chỗ',
  'Coming Soon': 'Sắp Ra Mắt',
  'New': 'Mới',
  'Popular': 'Phổ Biến',
  'Featured': 'Nổi Bật',
  'Recommended': 'Đề Xuất',
  'Best Seller': 'Bán Chạy Nhất',
  'Limited Time': 'Thời Gian Có Hạn',
  'Discount': 'Giảm Giá',
  'Free': 'Miễn Phí',
  'Premium': 'Cao Cấp',
  'Standard': 'Tiêu Chuẩn',
  'Basic': 'Cơ Bản',

  // Time & Date
  'Today': 'Hôm Nay',
  'Tomorrow': 'Ngày Mai',
  'Yesterday': 'Hôm Qua',
  'This Week': 'Tuần Này',
  'Next Week': 'Tuần Tới',
  'This Month': 'Tháng Này',
  'Next Month': 'Tháng Tới',
  'January': 'Tháng Một',
  'February': 'Tháng Hai',
  'March': 'Tháng Ba',
  'April': 'Tháng Tư',
  'May': 'Tháng Năm',
  'June': 'Tháng Sáu',
  'July': 'Tháng Bảy',
  'August': 'Tháng Tám',
  'September': 'Tháng Chín',
  'October': 'Tháng Mười',
  'November': 'Tháng Mười Một',
  'December': 'Tháng Mười Hai',
  'Monday': 'Thứ Hai',
  'Tuesday': 'Thứ Ba',
  'Wednesday': 'Thứ Tư',
  'Thursday': 'Thứ Năm',
  'Friday': 'Thứ Sáu',
  'Morning': 'Buổi Sáng',
  'Afternoon': 'Buổi Chiều',
  'Evening': 'Buổi Tối',
  'Night': 'Buổi Đêm',

  // Common UI Elements
  'Menu': 'Menu',
  'Navigation': 'Điều Hướng',
  'Footer': 'Chân Trang',
  'Header': 'Đầu Trang',
  'Sidebar': 'Thanh Bên',
  'Main Content': 'Nội Dung Chính',
  'Page': 'Trang',
  'of': 'của',
  'Show': 'Hiển Thị',
  'Hide': 'Ẩn',
  'Open': 'Mở',
  'Expand': 'Mở Rộng',
  'Collapse': 'Thu Gọn',
  'Toggle': 'Chuyển Đổi',
  'More': 'Thêm',
  'Less': 'Ít Hơn',
  'All': 'Tất Cả',
  'None': 'Không Có',
  'Other': 'Khác',
  'Select All': 'Chọn Tất Cả',
  'Deselect All': 'Bỏ Chọn Tất Cả',
  'Apply': 'Áp Dụng',
  'Reset': 'Đặt Lại',
  'Refresh': 'Làm Mới',
  'Reload': 'Tải Lại',

  // Pagination
  'First': 'Đầu Tiên',
  'Last': 'Cuối Cùng',
  'Go to page': 'Đi đến trang',
  'Items per page': 'Mục mỗi trang',
  'Showing': 'Hiển thị',
  'to': 'đến',
  'entries': 'mục',
  'No items to display': 'Không có mục nào để hiển thị',

  // Social Media & Sharing
  'Follow Us': 'Theo Dõi Chúng Tôi',
  'Share on Facebook': 'Chia Sẻ Trên Facebook',
  'Share on Twitter': 'Chia Sẻ Trên Twitter',
  'Share on Instagram': 'Chia Sẻ Trên Instagram',
  'Share on LinkedIn': 'Chia Sẻ Trên LinkedIn',
  'Copy Link': 'Sao Chép Liên Kết',
  'Link Copied': 'Đã Sao Chép Liên Kết',

  // Footer Content
  'All rights reserved': 'Tất cả quyền được bảo lưu',
  'Booking Policy': 'Chính Sách đặt chỗ và thanh toán',
  'Quick Links': 'Liên Kết Nhanh',
  'Useful Links': 'Liên Kết Hữu Ích',
  'Help': 'Trợ Giúp',
  'Support': 'Hỗ Trợ',
  'FAQ': 'Câu Hỏi Thường Gặp',
  'Newsletter': 'Bản Tin',
  'Subscribe': 'Đăng Ký',
  'Subscribe to our newsletter': 'Đăng ký nhận bản tin của chúng tôi',
  'Enter your email': 'Nhập email của bạn',
  'Company': 'Công Ty',
  'Address': 'Địa Chỉ',
  'Phone': 'Điện Thoại',
  'Email': 'Email',
  'Website': 'Trang Web',
    'TRANG THANH TRAVEL':'CÔNG TY TNHH TM - DV - DL TRANG THANH',
    '193 Co Bac, Cau Ong Lanh Ward, Ho Chi Minh City, Vietnam':'193 Cô Bắc, P. Cầu Ông Lãnh, TP. Hồ Chí Minh, Việt Nam',
    '(+84) 28 38 388 007':'(+84) 28 38 388 007',

  // Error Pages
  'Page Not Found': 'Không Tìm Thấy Trang',
  'The page you are looking for does not exist': 'Trang bạn đang tìm kiếm không tồn tại',
  'Go Back Home': 'Quay Về Trang Chủ',
  'Internal Server Error': 'Lỗi Máy Chủ Nội Bộ',
  'Something went wrong on our end': 'Đã xảy ra lỗi ở phía chúng tôi',

  // Accessibility
  'Skip to main content': 'Chuyển đến nội dung chính',
  'Close dialog': 'Đóng hộp thoại',
  'Open menu': 'Mở menu',
  'Close menu': 'Đóng menu',
  'Clear search': 'Xóa tìm kiếm',

  // Language Switcher
  'English': 'Tiếng Anh',
  'Vietnamese': 'Tiếng Việt',
  'Switch Language': 'Chuyển Ngôn Ngữ',

  // Additional Missing Translations
  'The tour you are looking for does not exist.': 'Tour bạn đang tìm kiếm không tồn tại.',
  'Browse Tours': 'Duyệt Tour',
  'Enter your full name': 'Nhập họ tên đầy đủ',
  'Enter your phone number': 'Nhập số điện thoại của bạn',
  'Contact person name': 'Tên người liên hệ',
  'Contact phone number': 'Số điện thoại liên hệ',
  'e.g., Spouse, Parent': 'ví dụ: Vợ/Chồng, Cha/Mẹ',
  'Any special requirements, dietary restrictions, medical conditions, or other requests...': 'Bất kỳ yêu cầu đặc biệt, hạn chế về chế độ ăn uống, tình trạng y tế hoặc yêu cầu khác...',
  'By clicking Book Now, you agree to our Terms of Service and Privacy Policy': 'Bằng cách nhấp vào Đặt Ngay, bạn đồng ý với Điều khoản Dịch vụ và Chính sách Bảo mật của chúng tôi',

  // Service Booking Additional Translations
  'The service you are looking for does not exist.': 'Dịch vụ bạn đang tìm kiếm không tồn tại.',
  'Browse Services': 'Duyệt Dịch Vụ',
  'Back to Service Details': 'Quay Lại Chi Tiết Dịch Vụ',
  'Service Summary': 'Tóm Tắt Dịch Vụ',
  'Total People': 'Tổng Số Người',
  'Trip Details': 'Chi Tiết Chuyến Đi',
  'Return Trip Required': 'Yêu Cầu Chuyến Về',
  'Additional Information': 'Thông Tin Bổ Sung',
  'Select gender': 'Chọn giới tính',
  'Male': 'Nam',
  'Female': 'Nữ',
  'Date of Birth': 'Ngày Sinh',
  'Enter your address': 'Nhập địa chỉ của bạn',
  'Any special requirements or requests...': 'Bất kỳ yêu cầu đặc biệt hoặc yêu cầu nào...',
  'By clicking Book Service, you agree to our Terms of Service and Privacy Policy': 'Bằng cách nhấp vào Đặt Dịch Vụ, bạn đồng ý với Điều khoản Dịch vụ và Chính sách Bảo mật của chúng tôi',
  'Enter pick-up location': 'Nhập địa điểm đón',
  'Enter drop-off location': 'Nhập địa điểm trả',
};

const TranslationContext = createContext<TranslationContextType | undefined>(undefined);

export const TranslationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<'en' | 'vi'>(() => {
    // Check localStorage or default to Vietnamese
    const saved = localStorage.getItem('language');
    if (saved !== null && (saved === 'en' || saved === 'vi')) {
      return saved as 'en' | 'vi';
    }
    return 'vi'; // Default to Vietnamese instead of English
  });

  // Save language preference to localStorage whenever it changes
  React.useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key: string): string => {
    if (language === 'vi' && vietnameseTranslations[key]) {
      return vietnameseTranslations[key];
    }
    return key; // Return the key itself if no translation found
  };

  // Helper function to get localized content from database objects
  const getLocalizedContent = (content: any, field: string): string => {
    if (!content) return '';

    if (language === 'vi') {
      const viField = `${field}_vi`;
      return content[viField] || content[field] || '';
    }

    return content[field] || '';
  };

  return (
    <TranslationContext.Provider value={{ language, setLanguage, t, getLocalizedContent }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (context === undefined) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
};
